import { buildReasonPage } from './reasonPageBuilder';
import { apportionmentInformationText as txt } from '../../definitions/constants';
import { CONVICTION_TYPE, FIELDS, YES_NO, noPriorAnswerYes } from './helpers';

export default buildReasonPage({
  path: 'surviving-spouse-or-child-incarceration',
  title: txt.survivingSpouseIncarcerationPageTitle,
  description: txt.reasonPageSubDescription,
  depends: formData =>
    noPriorAnswerYes(formData, [FIELDS.veteranIncarceratedOver60Days]),
  trigger: {
    name: FIELDS.survivingBeneficiaryIncarceratedOver60Days,
    title: txt.survivingBeneficiaryIncarceratedTitle,
    labels: txt.survivingBeneficiaryIncarceratedLabels,
    descriptions: txt.survivingBeneficiaryIncarceratedDescriptions,
    tile: true,
    options: YES_NO,
    error: txt.survivingBeneficiaryIncarceratedError,
  },
  conditionalFields: [
    {
      type: 'radio',
      name: FIELDS.survivingBeneficiaryIncarcerationFelonyOrMisdemeanor,
      title: txt.convictionFelonyOrMisdemeanorTitle,
      labels: txt.convictionTypeLabels,
      options: CONVICTION_TYPE,
      error: txt.convictionTypeError,
    },
    {
      type: 'text',
      name: FIELDS.survivingBeneficiaryFacilityName,
      title: txt.survivingBeneficiaryFacilityNameTitle,
      maxLength: 150,
      error: txt.survivingBeneficiaryFacilityNameError,
    },
    {
      type: 'text',
      name: FIELDS.survivingBeneficiaryFacilityAddress,
      title: txt.facilityAddressTitle,
      maxLength: 500,
      error: txt.survivingBeneficiaryFacilityAddressError,
    },
  ],
});
